import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import DoughnutChart from "./DoughnutChart";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import ToastMessage from "../../../utils/toasts/toastMessage";
import { finalResults } from "../../../Redux/test/test.action";
import Loader from "../../../utils/loader/loader";

const TestMCQ = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location?.state?.filterData
    ? location?.state?.filterData[0]
    : location?.state?.findData;

  const [open, setOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [score, setScore] = useState(0);
  const animationRef = useRef(null);
  const collapseAreaRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [questionsList, setQuestionsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState({});

  const [questionStatuses, setQuestionStatuses] = useState([]);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const testStoreQuestionList = data?.questions || data?.assignment_data;
  const assiginmentID = data?.assignment_id;
  const totalQues = data?.total_questions
    ? data?.total_questions
    : data?.total_questions;
  // const correctAnswers = data?.questionsList?.correct_answers ? data?.questionsList?.correct_answers : data?.total_questions ;
  const context = data?.context;

  useEffect(() => {
    if (testStoreQuestionList && totalQues) {
      setQuestionsList(testStoreQuestionList);
      setQuestionStatuses(
        Array.from({ length: totalQues }, (_, i) => ({
          id: i + 1,
          status: "",
        })),
      );
      setTimeLeft(totalQues * 1 * 60);
    }
  }, [testStoreQuestionList, totalQues]);

  const handleOptionChange = (questionId, selectedOption) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: selectedOption,
    }));
    setQuestionStatuses((prev) =>
      prev.map((q) => (q.id === questionId ? { ...q, status: "answered" } : q)),
    );
  };

  const allQuestions = [
    ...(questionsList?.mcq || []),
    ...(questionsList?.short_answer || []),
    ...(questionsList?.fill_in_the_blank || []),
  ];
  const totalQuestions = allQuestions.length;
  const handleNext = (e) => {
    e.preventDefault();
    if (currentIndex < totalQuestions - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      handleGenerateResult();
    }
  };

  // const handleGenerateResult = async () => {
  //   setScore("");
  //   setLoading(true);
  //   if (!questionsList) {
  //     setToastState({
  //       show: true,
  //       message: "Error on generating results",
  //       type: "error",
  //     });
  //     setLoading(false);
  //     return;
  //   }
  //   const updatedSelectedAnswers = {};

  //   allQuestions.forEach((_, index) => {
  //     const questionId = index + 1;

  //     updatedSelectedAnswers[questionId] = selectedAnswers[questionId]
  //       ?.toString()
  //       ?.trim()
  //       ? selectedAnswers[questionId]
  //       : "not answered";
  //   });

  //   const payload = {
  //     selectedAnswers: updatedSelectedAnswers,
  //     questions: testStoreQuestionList,
  //     assignment_id: assiginmentID,
  //     context: context,
  //   };
  //   try {
  //     const scoreResult = await dispatch(finalResults(payload));
  //     if (scoreResult !== null) {
  //       setScore(scoreResult);
  //       setShowModal(true);
  //     } else {
  //       setToastState({
  //         show: true,
  //         message: "Failed to generate result.",
  //         type: "error",
  //       });
  //     }
  //   } catch (error) {
  //     setToastState({
  //       show: true,
  //       message: "Something went wrong.",
  //       type: "error",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleGenerateResult = async () => {
  setScore("");
  setLoading(true);

  if (!questionsList) {
    setToastState({
      show: true,
      message: "Error on generating results",
      type: "error",
    });
    setLoading(false);
    return;
  }

  const updatedSelectedAnswers = {};

  allQuestions.forEach((_, index) => {
    const questionId = index + 1;

    updatedSelectedAnswers[questionId] = selectedAnswers[questionId]
      ?.toString()
      ?.trim()
      ? selectedAnswers[questionId]
      : "not answered";
  });

  const payload = {
    selectedAnswers: updatedSelectedAnswers,
    questions: testStoreQuestionList,
    assignment_id: assiginmentID,
    context: context,
  };

  const result = await dispatch(finalResults(payload));

  setLoading(false);

  if (result?.success) {
    setScore(result.score);
    setShowModal(true);
  } else {
    setToastState({
      show: true,
      message: result?.message || "Failed to generate result.",
      type: "error",
    });
  }
};
  const handleNavigate = () => {
    nav("/showallanswers", { state: testStoreQuestionList });
  };

  const handleSkip = () => {
    const currentQuestionId = currentIndex + 1;
    // Skip hone par status 'skipped' set kar rahe hain agar pehle se answered na ho
    setQuestionStatuses((prev) =>
      prev.map((q) =>
        q.id === currentQuestionId && q.status !== "answered"
          ? { ...q, status: "skipped" }
          : q,
      ),
    );

    if (currentIndex < totalQuestions - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      setShowModal(true);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };
  const handleModalResultClose = () => setShowModal(false);
  const handleModalOpen = () => {
    setShowModal(true);
  };
  const renderQuestion = () => {
    const question = allQuestions[currentIndex];
    const currentQuestionId = currentIndex + 1;
    const selected = selectedAnswers[currentQuestionId];
    if (question?.options) {
      return (
        <div className="mb-4">
          <h4 className="fw600 fz22 mb-3">{question?.question}</h4>
          <ul className="list-inline mcqs">
            {question?.options?.map((opt, idx) => {
              const optionId = `mcq-option-${currentIndex}-${idx}`;
              return (
                <li key={idx}>
                  <label htmlFor={optionId} className="w-100 radio-mcq">
                    <input
                      type="radio"
                      name={`mcq-${currentIndex}`}
                      id={optionId}
                      checked={selected === opt}
                      onChange={() =>
                        handleOptionChange(currentQuestionId, opt)
                      }
                    />
                    <div className="fw500 fz20">
                      {/* <span className="num">{opt.split(".")[0]}.</span>
                      <span className="ans">
                        {opt.substring(opt.indexOf(".") + 1).trim()}
                      </span> */}
                      <span className="ans">{opt}</span>
                    </div>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      );
      // } else if (typeof question === "string") {
    } else {
      return (
        <div className="mb-4">
          <h4 className="fw600 fz22 mb-3">{question?.question}</h4>
          <input
            type="text"
            className="form-control fw500 fz20"
            placeholder="Write your answer here..."
            value={selectedAnswers[currentQuestionId] || ""}
            onChange={(e) =>
              handleOptionChange(currentQuestionId, e.target.value)
            }
          />
        </div>
      );
    }
  };

  useEffect(() => {
    const modalElement = document.getElementById("resultModal");
    const handleModalShown = () => {
      const end = 75;
      const duration = 1500;
      const easeOutQuad = (t) => t * (2 - t);
      const startAnimation = () => {
        const startTime = performance.now();
        const animateScore = (currentTime) => {
          const elapsedTime = currentTime - startTime;
          const progress = Math.min(elapsedTime / duration, 1);
          const easedProgress = easeOutQuad(progress);
          setScore(Math.round(easedProgress * end));
          if (progress < 1) {
            animationRef.current = requestAnimationFrame(animateScore);
          }
        };
        animationRef.current = requestAnimationFrame(animateScore);
      };
      setTimeout(() => {
        requestAnimationFrame(startAnimation);
      }, 5);
    };
    if (modalElement) {
      modalElement.addEventListener("shown.bs.modal", handleModalShown);
    }
    return () => {
      if (modalElement) {
        modalElement.removeEventListener("shown.bs.modal", handleModalShown);
      }
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timer);
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Close "Question Completed" collapse when user clicks outside.
  useEffect(() => {
    if (!open) return;

    const handleOutsidePointerDown = (e) => {
      if (!collapseAreaRef.current) return;
      if (collapseAreaRef.current.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener("mousedown", handleOutsidePointerDown);
    document.addEventListener("touchstart", handleOutsidePointerDown, {
      passive: true,
    });

    return () => {
      document.removeEventListener("mousedown", handleOutsidePointerDown);
      document.removeEventListener("touchstart", handleOutsidePointerDown);
    };
  }, [open]);

  const formatTime = (time) => {
    const hh = String(Math.floor(time / 3600)).padStart(2, "0");
    const mm = String(Math.floor((time % 3600) / 60)).padStart(2, "0");
    const ss = String(time % 60).padStart(2, "0");
    return { hh, mm, ss };
  };
  const { hh, mm, ss } = formatTime(timeLeft);
  return (
    <>
      <section className="test-type">
        <div className="main-ques">
          <div className="me-2">
            <img
              src="/assets/images/box-arrow-left.svg"
              className="pointer-cursor"
              alt="Back"
              style={{ cursor: "pointer" }}
              onClick={() => nav("/test")}
              width="25"
              height="25"
            />
          </div>
          <div className="ff2 top-intro">
            <div className="top-intro__left">
              <h2 className="fz28 fw900">Give the correct answer.</h2>
            </div>
            {/* <div className="top-intro__right">
              <p className="fw500 mb-0 fz14 grayText">Time Remaining</p>
              <div className="fz24 fw700 timer">
                <span className="hh">{hh}</span>:
                <span className="mm">{mm}</span>:
                <span className="ss">{ss}</span>
              </div>
            </div> */}
          </div>
          <p className="grayText mb-0 fz16">
            {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
            convallis mattis lacus at bibendum. Interdum et malesuada fames ac
            ante ipsum primis in faucibus. */}
          </p>
        </div>
        <div className="QnA-block">
          <div className="QnA-block__top">
            <div className="left-gray">
              <h6 className="fz18 fw500">
                Question {currentIndex + 1} of {totalQuestions}
              </h6>
              <h2 className="fz28 fw900">
                {questionsList[currentIndex]?.title}
              </h2>
            </div>
            <div className="right-dark" ref={collapseAreaRef}>
              <div className="text-white info">
                <span className="fw500 fz16">Question Completed</span>
                <Button
                  className="btn-collapse"
                  onClick={() => setOpen(!open)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                >
                  <img
                    src="./assets/images/inner-pages/icons/icon-collapse--down.svg"
                    alt=""
                  />
                </Button>
                <span className="fz20 fw700 ms-auto">
                  {currentIndex}/{totalQuestions}
                </span>
              </div>
              <div className="answer-progress">
                <div
                  className="progress-bar"
                  style={{
                    width: `${((currentIndex + 1) / totalQuestions) * 100}%`,
                  }}
                />
              </div>
              <Collapse in={open}>
                <div id="example-collapse-text">
                  <div className="ques-pages">
                    <ul className="list-inline">
                      {questionStatuses.map((question, index) => (
                        <li key={question.id}>
                          <a
                            href="javascript:;"
                            className={`btn btn-round btn-roun--dark ${
                              question.status === "skipped"
                                ? "bg-danger text-white"
                                : question.status
                            } ${currentIndex === index ? "active" : ""}`}
                            onClick={() => setCurrentIndex(index)}
                          >
                            {question.id}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
          <div className="QnA-block__bottom">
            {renderQuestion()}
            <div className="group-btns d-flex gap-2">
              {currentIndex > 0 && (
                <button
                  className="fw500 fz20 btn btn-outlined btn-outlined--dark"
                  onClick={handleBack}
                >
                  Back
                </button>
              )}
              {currentIndex < totalQuestions - 1 && (
                <button
                  className="fw500 fz20 btn btn-outlined btn-outlined--dark"
                  onClick={handleSkip}
                >
                  Skip
                </button>
              )}
              <button
                className="fw500 fz20 btn btn-solid btn-solid--dark"
                onClick={(e) => handleNext(e)}
              >
                {currentIndex === totalQuestions - 1 ? "Finish" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </section>
      {showModal && (
        <div
          className="modal fade show"
          id="resultModal"
          tabIndex={-1}
          aria-labelledby="resultModalLabel"
          aria-hidden="true"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="border-0 bdrs40 modal-content">
              <div className="w-100 result-content">
                <button
                  type="button"
                  className="rounded-circle ts03 btn-close"
                  onClick={handleModalResultClose}
                />
                <div className="w-100 success-chart">
                  <DoughnutChart
                    elementId="resultDonut"
                    // color="#000"
                    color="green"
                    dataValue={score}
                    graphBorder="70%"
                    modalId="resultModal"
                  />
                  <div className="inner-num">
                    <div className="fw700 fz44">{score}%</div>
                    <p className="fz16 mb-0">Final Score</p>
                  </div>
                </div>
                <h4 className="fz28 fw500 lh1">Test Result</h4>
                <button
                  className="w-100 btn btn-solid btn-solid--dark fz18"
                  onClick={handleNavigate}
                >
                  See Your Answers
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Loader show={loading} />
      <ToastMessage
        show={toastState.show}
        onClose={() => setToastState({ show: false, message: "", type: "" })}
        message={toastState.message}
        type={toastState.type}
      />
    </>
  );
};
export default TestMCQ;
